module.exports = __webpack_public_path__ + "static/owie-e1a86fd1d77b1c0b3c025086af89ebd5.png";